import React, { useState } from 'react';
import { useAppContext } from '../App';

const ProductModal = ({ product, isOpen, onClose, onContact }) => {
  const [quantity, setQuantity] = useState(100);
  const [message, setMessage] = useState('');
  const [activeTab, setActiveTab] = useState('details');

  if (!isOpen || !product) return null;

  const handleContact = () => {
    onContact(product);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        <div className="modal-header">
          <div className="modal-image">
            <img src={product.image} alt={product.name} />
            <span className="modal-category">{product.category}</span>
          </div>
          <div className="modal-title-section">
            <h2 className="modal-title">{product.name}</h2>
            <div className="modal-meta">
              <span className="modal-cas">CAS#: {product.casNumber}</span>
              <span className="modal-purity">Purity: {product.purity}</span>
            </div>
          </div>
        </div>

        <div className="modal-tabs">
          <button
            className={`modal-tab ${activeTab === 'details' ? 'active' : ''}`}
            onClick={() => setActiveTab('details')}
          >
            Details
          </button>
          <button
            className={`modal-tab ${activeTab === 'specs' ? 'active' : ''}`}
            onClick={() => setActiveTab('specs')}
          >
            Specifications
          </button>
          <button
            className={`modal-tab ${activeTab === 'supplier' ? 'active' : ''}`}
            onClick={() => setActiveTab('supplier')}
          >
            Supplier
          </button>
        </div>

        <div className="modal-body">
          {activeTab === 'details' && (
            <div className="tab-content">
              <div className="detail-grid">
                <div className="detail-item">
                  <span className="detail-label">Chemical Name</span>
                  <span className="detail-value">{product.name}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">CAS Number</span>
                  <span className="detail-value mono">{product.casNumber}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Category</span>
                  <span className="detail-value">{product.category}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Purity</span>
                  <span className="detail-value">{product.purity}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Min. Order</span>
                  <span className="detail-value">25 kg</span>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'specs' && (
            <div className="tab-content">
              <div className="specs-table">
                <div className="spec-row">
                  <span className="spec-label">Appearance</span>
                  <span className="spec-value">White crystalline powder</span>
                </div>
                <div className="spec-row">
                  <span className="spec-label">Molecular Weight</span>
                  <span className="spec-value">288.38 g/mol</span>
                </div>
                <div className="spec-row">
                  <span className="spec-label">Melting Point</span>
                  <span className="spec-value">204-207°C</span>
                </div>
                <div className="spec-row">
                  <span className="spec-label">Boiling Point</span>
                  <span className="spec-value">Decomposes</span>
                </div>
                <div className="spec-row">
                  <span className="spec-label">Solubility</span>
                  <span className="spec-value">Soluble in water</span>
                </div>
                <div className="spec-row">
                  <span className="spec-label">Storage</span>
                  <span className="spec-value">Cool, dry place</span>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'supplier' && (
            <div className="tab-content">
              <div className="supplier-info">
                <div className="supplier-header">
                  <div className="supplier-avatar">
                    {product.supplier.charAt(0)}
                  </div>
                  <div className="supplier-details">
                    <h4 className="supplier-name">{product.supplier}</h4>
                    <div className="supplier-badges">
                      <span className="badge badge-verified">✓ Verified</span>
                      <span className="badge badge-premium">Premium</span>
                    </div>
                  </div>
                </div>
                <div className="supplier-stats">
                  <div className="stat">
                    <span className="stat-value">4.8</span>
                    <span className="stat-label">Rating</span>
                  </div>
                  <div className="stat">
                    <span className="stat-value">250+</span>
                    <span className="stat-label">Products</span>
                  </div>
                  <div className="stat">
                    <span className="stat-value">&lt;2h</span>
                    <span className="stat-label">Response</span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <div className="quantity-selector">
            <label>Quantity (kg):</label>
            <div className="quantity-inputs">
              <button
                className="qty-btn"
                onClick={() => setQuantity(Math.max(25, quantity - 25))}
              >
                -
              </button>
              <input
                type="number"
                value={quantity}
                onChange={(e) => setQuantity(Math.max(25, parseInt(e.target.value) || 25))}
                min="25"
              />
              <button
                className="qty-btn"
                onClick={() => setQuantity(quantity + 25)}
              >
                +
              </button>
            </div>
          </div>

          <div className="modal-actions">
            <button className="btn btn-outline" onClick={onClose}>
              Close
            </button>
            <button className="btn btn-primary" onClick={handleContact}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
              </svg>
              Contact Supplier
            </button>
          </div>
        </div>

        <style jsx>{`
          .modal-overlay {
            position: fixed;
            inset: 0;
            background: rgba(0, 0, 0, 0.8);
            backdrop-filter: blur(8px);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1000;
            padding: var(--space-lg);
            animation: fadeIn 0.2s ease;
          }

          .modal-content {
            background: linear-gradient(135deg, rgba(30, 41, 59, 0.98), rgba(15, 23, 42, 0.98));
            border: 1px solid rgba(59, 130, 246, 0.3);
            border-radius: var(--radius-xl);
            width: 100%;
            max-width: 700px;
            max-height: 90vh;
            overflow-y: auto;
            position: relative;
            animation: scaleIn 0.3s ease;
          }

          .modal-close {
            position: absolute;
            top: var(--space-md);
            right: var(--space-md);
            width: 36px;
            height: 36px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(255, 255, 255, 0.1);
            border: none;
            border-radius: 50%;
            color: var(--color-neutral-300);
            cursor: pointer;
            transition: all var(--transition-fast);
            z-index: 1;
          }

          .modal-close:hover {
            background: rgba(239, 68, 68, 0.3);
            color: #ef4444;
          }

          .modal-header {
            display: flex;
            gap: var(--space-lg);
            padding: var(--space-xl);
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          }

          .modal-image {
            position: relative;
            width: 160px;
            height: 160px;
            border-radius: var(--radius-lg);
            overflow: hidden;
            flex-shrink: 0;
          }

          .modal-image img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          .modal-category {
            position: absolute;
            bottom: var(--space-sm);
            left: var(--space-sm);
            font-size: var(--font-xs);
            padding: 2px var(--space-sm);
            background: rgba(59, 130, 246, 0.9);
            color: white;
            border-radius: var(--radius-sm);
            text-transform: uppercase;
          }

          .modal-title-section {
            flex: 1;
          }

          .modal-title {
            font-family: var(--font-display);
            font-size: var(--font-2xl);
            font-weight: 600;
            color: var(--color-neutral-50);
            margin-bottom: var(--space-sm);
          }

          .modal-meta {
            display: flex;
            gap: var(--space-md);
            margin-bottom: var(--space-md);
          }

          .modal-cas, .modal-purity {
            font-size: var(--font-sm);
            color: var(--color-neutral-400);
          }

          .modal-cas {
            font-family: var(--font-mono);
          }

          .modal-price {
            font-family: var(--font-display);
            font-size: var(--font-2xl);
            font-weight: 700;
            color: var(--color-accent-300);
          }

          .modal-tabs {
            display: flex;
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
            padding: 0 var(--space-xl);
          }

          .modal-tab {
            font-family: var(--font-body);
            font-size: var(--font-sm);
            font-weight: 500;
          }

          .tab-content {
            padding: var(--space-xl);
            animation: fadeIn 0.2s ease;
          }

          .detail-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: var(--space-md);
          }

          .detail-item {
            display: flex;
            flex-direction: column;
            gap: var(--space-xs);
            padding: var(--space-md);
            background: rgba(255, 255, 255, 0.03);
            border-radius: var(--radius-md);
          }

          .detail-label {
            font-size: var(--font-xs);
            color: var(--color-neutral-500);
            text-transform: uppercase;
            letter-spacing: 0.05em;
          }

          .detail-value {
            font-size: var(--font-base);
            color: var(--color-neutral-200);
          }

          .detail-value.highlight {
            color: var(--color-accent-300);
            font-weight: 600;
          }

          .detail-value.mono {
            font-family: var(--font-mono);
          }

          .specs-table {
            display: flex;
            flex-direction: column;
            gap: var(--space-sm);
          }

          .spec-row {
            display: flex;
            justify-content: space-between;
            padding: var(--space-sm) var(--space-md);
            background: rgba(255, 255, 255, 0.03);
            border-radius: var(--radius-sm);
          }

          .spec-label {
            font-size: var(--font-sm);
            color: var(--color-neutral-400);
          }

          .spec-value {
            font-size: var(--font-sm);
            color: var(--color-neutral-200);
          }

          .supplier-info {
            display: flex;
            flex-direction: column;
            gap: var(--space-lg);
          }

          .supplier-header {
            display: flex;
            align-items: center;
            gap: var(--space-md);
          }

          .supplier-avatar {
            width: 56px;
            height: 56px;
            background: linear-gradient(135deg, var(--color-accent-500), var(--color-accent-300));
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: var(--font-display);
            font-size: var(--font-xl);
            font-weight: 700;
            color: white;
          }

          .supplier-name {
            font-family: var(--font-display);
            font-size: var(--font-lg);
            font-weight: 600;
            color: var(--color-neutral-50);
            margin-bottom: var(--space-xs);
          }

          .supplier-badges {
            display: flex;
            gap: var(--space-sm);
          }

          .supplier-stats {
            display: flex;
            gap: var(--space-xl);
            padding: var(--space-md);
            background: rgba(255, 255, 255, 0.03);
            border-radius: var(--radius-md);
          }

          .stat {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: var(--space-xs);
          }

          .stat-value {
            font-family: var(--font-display);
            font-size: var(--font-xl);
            font-weight: 700;
            color: var(--color-accent-400);
          }

          .stat-label {
            font-size: var(--font-xs);
            color: var(--color-neutral-500);
          }

          .modal-footer {
            padding: var(--space-lg) var(--space-xl);
            border-top: 1px solid rgba(255, 255, 255, 0.1);
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: var(--space-lg);
          }

          .quantity-selector {
            display: flex;
            align-items: center;
            gap: var(--space-md);
          }

          .quantity-selector label {
            font-size: var(--font-sm);
            color: var(--color-neutral-400);
          }

          .quantity-inputs {
            display: flex;
            align-items: center;
            gap: var(--space-xs);
          }

          .qty-btn {
            width: 32px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(255, 255, 255, 0.1);
            border: 1px solid rgba(255, 255, 255, 0.2);
            border-radius: var(--radius-sm);
            color: var(--color-neutral-200);
            font-size: var(--font-lg);
            cursor: pointer;
            transition: all var(--transition-fast);
          }

          .qty-btn:hover {
            background: rgba(59, 130, 246, 0.2);
            border-color: var(--color-accent-400);
          }

          .quantity-inputs input {
            width: 70px;
            text-align: center;
            background: rgba(255, 255, 255, 0.05);
            border: 1px solid rgba(255, 255, 255, 0.2);
            border-radius: var(--radius-sm);
            padding: var(--space-xs) var(--space-sm);
            color: var(--color-neutral-100);
            font-family: var(--font-mono);
            font-size: var(--font-sm);
          }

          .total-price {
            font-size: var(--font-sm);
            color: var(--color-accent-300);
            font-weight: 500;
          }

          .modal-actions {
            display: flex;
            gap: var(--space-sm);
          }

          .modal-actions .btn {
            display: flex;
            align-items: center;
            gap: var(--space-sm);
          }

          @media (max-width: 640px) {
            .modal-header {
              flex-direction: column;
              align-items: center;
              text-align: center;
            }

            .modal-meta {
              justify-content: center;
            }

            .detail-grid {
              grid-template-columns: 1fr;
            }

            .modal-footer {
              flex-direction: column;
              align-items: stretch;
            }

            .quantity-selector {
              justify-content: space-between;
            }

            .modal-actions {
              justify-content: stretch;
            }

            .modal-actions .btn {
              flex: 1;
            }
          }
        `}</style>
      </div>
    </div>
  );
};

export default ProductModal;
